import { render, staticRenderFns } from "./InventoryManager.vue?vue&type=template&id=0f460b54&"
import script from "./InventoryManager.vue?vue&type=script&lang=js&"
export * from "./InventoryManager.vue?vue&type=script&lang=js&"
import style0 from "./InventoryManager.vue?vue&type=style&index=0&id=0f460b54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports